/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLinkAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 12a5 5 0 0 1 5-5h4v2H7a3 3 0 1 0 0 6h4v2H7a5 5 0 0 1-5-5zm20 0a5 5 0 0 1-5 5h-4v-2h4a3 3 0 1 0 0-6h-4V7h4a5 5 0 0 1 5 5z" />
        <path d="M7 13h10v-2H7z" />
      </g>
    </g>
  </Icon>
);
export { SvgLinkAlt as LinkAlt };
